import { render, staticRenderFns } from "./UserCompanies.vue?vue&type=template&id=4d7c886e"
import script from "./UserCompanies.vue?vue&type=script&lang=ts"
export * from "./UserCompanies.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports